
import {
  queryTakenOrderSumInfo,
  queryTakenOrderInfoPage,
  queryTakenOrderInfo,
  queryTakenOrderDetailInfo,
  addPriceChangeApprovalRecord,
  priceChangeApprovalRecordList,
  queryPurchaseConfig,
  saveFxRelation,
  detailInfo,
  queryCgShareUrl,
  queryPurchaserPageList,
  countPriceChangeApprovalRecord
} from '@api/dangkou/index.js';


/**
 * 待出货采购商数据汇总
 */
export const getTakenOrderSum = (data) => {
  return queryTakenOrderSumInfo(data).then(({ data }) => {
    return data || {};
  })
}

/**
 * 采购商待拿、待退商品统计数据
 */
export const getTakenOrderInfoPage = (data) => {
  return queryTakenOrderInfoPage(data).then(({ data }) => {
    return data || {};
  })
}
/**
 * 查询单个 采购商待拿、待退商品统计详情数据
 */
export const getTakenOrderInfo = (data) => {
  return queryTakenOrderInfo(data).then(({ data }) => {
    return data || {};
  })
}
/**
 * 统计供应商下，商品维度待拿、待退金额、数量，及标签已打印次数
 */
export const getTakenOrderDetailList = (data) => {
  return queryTakenOrderDetailInfo(data).then(({ data }) => {
    return data || {};
  })
}

/**
 * 统计商品改价次数
 */
export const getChangePriceCount = (data) => {
  return countPriceChangeApprovalRecord(data).then(({ data }) => {
    return data || 0;
  })
}
/**
 * 改供货价
 */
export const changePriceApprovalRecord = (data) => {
  return addPriceChangeApprovalRecord(data).then(({ data }) => {
    return data;
  })
}

/**
 * 查询商品改价记录
 */
export const getPriceChangeApprovalRecordList = (data) => {
  return priceChangeApprovalRecordList(data).then(({ data }) => {
    return data || {};
  })
}

/**
 * 获取采购配置
 */
export const getPurchaseConfig = (data) => {
  return queryPurchaseConfig(data).then(({ data }) => {
    return data || {};
  })
}

// 匹配ERP商品
export const mateErpGoods = (data) => {
  return saveFxRelation(data).then(({ data }) => {
    return data;
  })
}

// 查询采购商信息
export const getContactDetailInfo = (data) => {
  return detailInfo(data).then(({ data }) => {
    return data || {};
  })
}

// 查询采购商信息
export const getCgShareUrl = (data) => {
  return queryCgShareUrl(data).then(({ data }) => {
    return data || {};
  })
}

// 查询采购商list
export const getPurchaserPageList = (data) => {
  return queryPurchaserPageList(data).then(({ data }) => {
    return data || {};
  })
}




